/**
 * Valida se o tipo de conta informado é válido: se for diferente de 'pf' e diferente de 'pj', é considerado inválido
 * @param {str} tipoConta -> esperado 'pf' ou 'pj'.
 * @returns {boolean} true|false
 */
export function isValidTipoConta(tipoConta) {
  return tipoConta == 'pf' || tipoConta == 'pj';
}